<template>
	<edit></edit>
</template>

<script>
	import edit from './recommended_edit.vue'
	export default {
		name: 'recommended_add',
		
		components: {
			edit
		}
	}
</script>